import { escapeHtml } from "@/features/utils";

export const customTextTemplate = (ctx: any) => {
  return `<div class="custom-text-component">${escapeHtml(
    ctx.schema.content || ""
  )}</div>`;
};
